import { LEARNING_GOAL_OPTIONS } from 'bundles/onboarding-common/constants';
import type { LearnerProfileLearningGoalQueryQuery } from 'bundles/onboarding-common/queries/__generated__/LearnerProfileLearningGoal';

const formatLearningGoalFromLearnerProfile = (learningGoalData?: LearnerProfileLearningGoalQueryQuery) => {
  switch (learningGoalData?.LearnerProfile?.me?.learningPrograms?.learningGoal) {
    case 'CHANGE_CAREER':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_CHANGE_CAREER;
    case 'IMPROVE_SKILLS':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS;
    case 'LAND_NEW_JOB':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_LAND_NEW_JOB;
    case 'PERSONAL_INTEREST':
      return LEARNING_GOAL_OPTIONS.LEARNING_GOAL_PERSONAL_INTEREST;
    default:
      return null;
  }
};

export { formatLearningGoalFromLearnerProfile };
